import { render, staticRenderFns } from "./ColorSystemInput.vue?vue&type=template&id=99ee8d10"
import script from "./ColorSystemInput.vue?vue&type=script&lang=js"
export * from "./ColorSystemInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports